(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cdi-announcement"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  var sliders = document.querySelectorAll('[data-announcement-slider]');
  var prefersReduced =
    window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  sliders.forEach(function (slider) {
    var track = slider.querySelector('[data-announcement-track]');
    var slides = track ? Array.from(track.querySelectorAll('.cdi-announcement__slide')) : [];
    if (slides.length < 2) return;

    var current = 0;
    var total = slides.length;
    var intervalId = null;
    var INTERVAL_MS = 5000;

    function goTo(index) {
      slides[current].setAttribute('aria-hidden', 'true');
      slides[current].classList.remove('is-active');
      current = (index + total) % total;
      slides[current].setAttribute('aria-hidden', 'false');
      slides[current].classList.add('is-active');
      track.setAttribute('aria-label', current + 1 + ' / ' + total);
    }

    function startAuto() {
      if (prefersReduced || intervalId) return;
      intervalId = setInterval(function () {
        if (!document.hidden) goTo(current + 1);
      }, INTERVAL_MS);
    }

    function stopAuto() {
      clearInterval(intervalId);
      intervalId = null;
    }

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            startAuto();
          } else {
            stopAuto();
          }
        });
      },
      { threshold: 0 }
    );
    io.observe(slider);

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) {
        stopAuto();
      } else {
        startAuto();
      }
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cdi-cmsl-anchor-nav"] && !Shopify.designMode) return;
  try {
    
(function () {
  var nav      = document.querySelector('.cmsl-anchor-nav');
  var sentinel = document.querySelector('.cmsl-anchor-nav__sentinel');
  if (!nav || !sentinel) return;

  var navTop    = 0;
  var navHeight = 0;
  var isFixed   = false;

  var isScrollingToAnchor = false;

  function calcNavTop() {
    if (isFixed) {
      nav.classList.remove('is-fixed');
      sentinel.style.height = '0';
      isFixed = false;
    }
    var top = 0, el = nav;
    while (el) { top += el.offsetTop; el = el.offsetParent; }
    navTop    = top;
    navHeight = nav.offsetHeight;
    onScroll();
  }
  function onScroll() {
    var y = window.CdiScrollLock ? window.CdiScrollLock.getScrollY() : window.scrollY;
    if (y >= navTop && !isFixed) {
      sentinel.style.height = navHeight + 'px';
      nav.classList.add('is-fixed');
      isFixed = true;
    } else if (y < navTop && isFixed && !isScrollingToAnchor) {
      nav.classList.remove('is-fixed');
      sentinel.style.height = '0';
      isFixed = false;
    }
  }
  calcNavTop();
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', calcNavTop, { passive: true });
  var ANCHOR_GAP = 8;
  function getAbsoluteTop(el) {
    var top = 0;
    while (el) { top += el.offsetTop; el = el.offsetParent; }
    return top;
  }
  function scrollToAnchor(targetId) {
    var target = document.getElementById(targetId);
    if (!target) return;

    var targetAbsTop = getAbsoluteTop(target);
    var targetY = Math.max(navTop, targetAbsTop - navHeight - ANCHOR_GAP);
    isScrollingToAnchor = true;
    window.scrollTo({ top: targetY, behavior: 'smooth' });
    var unlocked = false;
    function unlock() {
      if (unlocked) return;
      unlocked = true;
      isScrollingToAnchor = false;
      window.removeEventListener('scrollend', unlock);
      clearTimeout(fallback);
      onScroll();
    }
    window.addEventListener('scrollend', unlock, { once: true });
    var fallback = setTimeout(unlock, 1000);
  }
  nav.querySelectorAll('[data-anchor]').forEach(function (link) {
    link.addEventListener('click', function (e) {
      e.preventDefault();
      scrollToAnchor(link.dataset.anchor);
    });
  });
  nav.querySelectorAll('.cmsl-anchor-nav__cta[data-query]').forEach(function (a) {
    var arm = function () {
      if (a.href.indexOf('?') === -1) a.href = a.getAttribute('href') + '?' + a.dataset.query;
    };
    ['pointerdown', 'focus', 'contextmenu'].forEach(function (type) { a.addEventListener(type, arm); });
  });
  document.querySelectorAll('[data-anchor-target]').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      var id = (btn.dataset.anchorTarget || '').replace('#', '');
      if (id) {
        e.preventDefault();
        scrollToAnchor(id);
      }
    });
  });
  var anchors = Array.from(nav.querySelectorAll('[data-anchor]'));
  var sectionIds = anchors.map(function (a) { return a.dataset.anchor; });

  if ('IntersectionObserver' in window && sectionIds.length) {
    var activeId = null;
    var tabsList = nav.querySelector('.cmsl-anchor-nav__anchor-list');
    function scrollTabIntoView(anchorId) {
      if (!tabsList) return;
      var activeLink = anchors.find(function (a) { return a.dataset.anchor === anchorId; });
      if (!activeLink) return;
      var li = activeLink.closest('li');
      if (!li) return;
      var target = li.offsetLeft - (tabsList.clientWidth - li.offsetWidth) / 2;
      tabsList.scrollTo({ left: Math.max(0, target), behavior: 'smooth' });
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          activeId = entry.target.id;
          anchors.forEach(function (a) {
            a.classList.toggle('is-active', a.dataset.anchor === activeId);
          });
          scrollTabIntoView(activeId);
        }
      });
    }, { rootMargin: '-' + (navHeight + 8) + 'px 0px -60% 0px', threshold: 0 });
    sectionIds.forEach(function (id) {
      var el = document.getElementById(id);
      if (el) io.observe(el);
    });
  }

  window.addEventListener('pagehide', function () {
    if (isFixed) {
      nav.classList.remove('is-fixed');
      sentinel.style.height = '0';
      isFixed = false;
    }
  });
  window.addEventListener('pageshow', function (e) {
    if (!e.persisted) return;
    calcNavTop();
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cdi-cmsl-configurations"] && !Shopify.designMode) return;
  try {
    
(function () {
  var section = document.querySelector('.cmsl-config[id="cmsl-configurations"]');
  if (!section) return;

  var _model = '2door';
  var _colour = 'black';
  var modelTabsEl = section.querySelector('.cmsl-config__model-tabs');
  var modelPill = section.querySelector('.cmsl-config__model-tabs-pill');
  var cta = section.querySelector('.cmsl-config__cta[data-builder-url]');
  var DOOR = { '2door': 'door_2', '3door': 'door_3_rear', dogbox: 'door_3_half_dog' };
  var FINISH = { black: 'finish_sahara', white: 'finish_splash' };

  function updateCta() {
    if (!cta) return;
    cta.dataset.query = 'from=setup&door=' + (DOOR[_model] || 'door_2') + '&finish=' + (FINISH[_colour] || 'finish_sahara');
    if (document.activeElement === cta) armCta();
  }

  function armCta() {
    if (cta) cta.href = cta.dataset.builderUrl + '?' + cta.dataset.query;
  }

  if (cta) {
    ['pointerdown', 'focus', 'contextmenu'].forEach(function (type) {
      cta.addEventListener(type, armCta);
    });
  }

  function updateModelPill() {
    if (!modelPill || !modelTabsEl) return;
    var activeBtn = modelTabsEl.querySelector('.cmsl-config__model-tab.is-active');
    if (!activeBtn) return;
    requestAnimationFrame(function () {
      modelPill.style.left   = activeBtn.offsetLeft + 'px';
      modelPill.style.top    = activeBtn.offsetTop + 'px';
      modelPill.style.width  = activeBtn.offsetWidth + 'px';
      modelPill.style.height = activeBtn.offsetHeight + 'px';
      modelPill.classList.add('is-ready');
    });
  }

  function updateImage() {
    var key = _model + '-' + _colour;
    section.querySelectorAll('.cmsl-config__img').forEach(function (img) {
      var active = img.dataset.configImg === key;
      img.classList.toggle('is-active', active);
    });
  }

  function updateModelDesc() {
    section.querySelectorAll('.cmsl-config__model-desc').forEach(function (el) {
      el.classList.toggle('is-active', el.dataset.modelDesc === _model);
    });
  }

  function updateModelPrice() {
    section.querySelectorAll('.cmsl-config__price').forEach(function (el) {
      el.classList.toggle('is-active', el.dataset.modelPrice === _model);
    });
  }

  section.querySelectorAll('.cmsl-config__model-tab:not(.is-soon)').forEach(function (btn) {
    btn.addEventListener('click', function () {
      _model = btn.dataset.model;
      section.querySelectorAll('.cmsl-config__model-tab').forEach(function (t) {
        var active = t.dataset.model === _model;
        t.classList.toggle('is-active', active);
        t.setAttribute('aria-selected', active ? 'true' : 'false');
      });
      updateModelDesc();
      updateModelPrice();
      updateImage();
      updateModelPill();
      updateCta();
    });
  });

  updateModelPill();

  var pillResizeTimer;
  window.addEventListener('resize', function () {
    clearTimeout(pillResizeTimer);
    pillResizeTimer = setTimeout(updateModelPill, 100);
  }, { passive: true });

  section.querySelectorAll('.cmsl-config__colour').forEach(function (btn) {
    btn.addEventListener('click', function () {
      _colour = btn.dataset.colour;
      section.querySelectorAll('.cmsl-config__colour').forEach(function (c) {
        var active = c.dataset.colour === _colour;
        c.classList.toggle('is-active', active);
        c.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
      updateImage();
      updateCta();
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cdi-cmsl-extras-rail"] && !Shopify.designMode) return;
  try {
    
(function () {
  class CdiExtrasRail extends HTMLElement {
    connectedCallback() {
      this._currentIndex  = 0;
      this._userInteracted = false;
      this._track    = this.querySelector('[data-extras-rail-track]');
      this._desc     = this.querySelector('[data-extras-rail-desc]');
      this._slides   = Array.from(this.querySelectorAll('[data-slide-index]'));
      this._tabs     = Array.from(this.querySelectorAll('[data-extras-rail-tab]'));
      this._tabsList = this.querySelector('.cmsl-extras-rail__tabs');
      this._btnPrev  = this.querySelector('[data-extras-rail-prev]');
      this._btnNext  = this.querySelector('[data-extras-rail-next]');
      this._total    = this._slides.length;
      this._descriptions = this._slides.map(function (s) { return s.dataset.desc || ''; });

      if (this._total < 2) return;

      this._injectIndicator();

      var self = this;
      this._btnPrev.addEventListener('click', function () { self._go(self._currentIndex - 1); });
      this._btnNext.addEventListener('click', function () { self._go(self._currentIndex + 1); });

      this._tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          self._userInteracted = true;
          self._go(parseInt(tab.dataset.extrasRailTab, 10));
        });
      });

      if (window.matchMedia('(pointer: coarse)').matches) {
        var startX = 0, startY = 0, dragging = false;
        var stage = this.querySelector('.cmsl-extras-rail__stage');
        stage.addEventListener('pointerdown', function (e) {
          startX = e.clientX; startY = e.clientY; dragging = true;
          stage.setPointerCapture(e.pointerId);
        });
        stage.addEventListener('pointermove', function (e) {
          if (!dragging) return;
          var dx = e.clientX - startX, dy = e.clientY - startY;
          if (Math.abs(dx) > 8 && Math.abs(dx) > Math.abs(dy)) e.preventDefault();
        }, { passive: false });
        stage.addEventListener('pointerup', function (e) {
          if (!dragging) return;
          dragging = false;
          var dx = e.clientX - startX, dy = e.clientY - startY;
          if (Math.abs(dx) > 12 && Math.abs(dx) > Math.abs(dy)) {
            self._userInteracted = true;
            self._go(dx < 0 ? self._currentIndex + 1 : self._currentIndex - 1);
          }
        });
        stage.addEventListener('pointercancel', function () { dragging = false; });
      }

      var resizeTimer;
      window.addEventListener('resize', function () {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(function () {
          self._setTrackPosition(self._currentIndex, false);
        }, 100);
      }, { passive: true });

      this._setTrackPosition(0, false);
      if (this._desc) this._desc.textContent = this._descriptions[0] || '';
    }

    _go(idx) {
      if (idx < 0 || idx >= this._total) return;
      this._currentIndex = idx;
      this._setTrackPosition(idx, true);
    }

    _gap() {
      return parseFloat(window.getComputedStyle(this._track).gap) || 20;
    }

    _setTrackPosition(idx, animate) {
      var slideW = this._slides[0] ? this._slides[0].offsetWidth : 0;
      var tx = -idx * (slideW + this._gap());

      var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (!animate || reducedMotion) {
        this._track.style.transition = 'none';
        this._track.style.transform  = 'translateX(' + tx + 'px)';
        if (animate) {
          var track = this._track;
          requestAnimationFrame(function () {
            requestAnimationFrame(function () { track.style.transition = ''; });
          });
        }
      } else {
        this._track.style.transition = '';
        this._track.style.transform  = 'translateX(' + tx + 'px)';
      }

      this._slides.forEach(function (s, i) { s.classList.toggle('is-active', i === idx); });

      this._tabs.forEach(function (t, i) {
        t.classList.toggle('is-active', i === idx);
        t.setAttribute('aria-selected', i === idx ? 'true' : 'false');
      });

      this._updateIndicator(idx);

      if (this._btnPrev) this._btnPrev.disabled = idx === 0;
      if (this._btnNext) this._btnNext.disabled = idx === this._total - 1;

      if (animate) this._updateDesc(this._descriptions[idx]);
    }

    _injectIndicator() {
      if (!this._tabsList) return;
      var indicator = document.createElement('span');
      indicator.className = 'cmsl-extras-rail__tabs-indicator';
      indicator.setAttribute('aria-hidden', 'true');
      this._tabsList.insertBefore(indicator, this._tabsList.firstChild);
      this._indicator = indicator;
      var self = this;
      requestAnimationFrame(function () { self._updateIndicator(0); });
    }

    _updateIndicator(idx) {
      var tab = this._tabs[idx];
      var indicator = this._indicator;
      if (!tab || !indicator) return;
      var left  = tab.offsetLeft;
      var style = window.getComputedStyle(tab);
      var paddingRight = parseFloat(style.paddingRight) || 0;
      var width = tab.offsetWidth - paddingRight;
      requestAnimationFrame(function () {
        indicator.style.left  = left + 'px';
        indicator.style.width = width + 'px';
      });
    }

    _updateDesc(text) {
      if (!this._desc || text === undefined) return;
      var desc = this._desc;
      desc.style.opacity = '0';
      clearTimeout(this._descTimer);
      this._descTimer = setTimeout(function () {
        desc.textContent = text;
        desc.style.opacity = '1';
      }, 160);
    }
  }

  if (!customElements.get('cdi-extras-rail')) {
    customElements.define('cdi-extras-rail', CdiExtrasRail);
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cdi-cmsl-hero"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('.cmsl-hero__image').forEach(function (img) {
    function reveal() { img.classList.add('cmsl-hero__image--loaded'); }
    if (img.complete && img.naturalWidth > 0) {
      reveal();
    } else {
      img.addEventListener('load',  reveal, { once: true });
      img.addEventListener('error', reveal, { once: true });
    }
  });

})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cdi-cmsl-inclusions-floor-fitout"] && !Shopify.designMode) return;
  try {
    
(function () {
  var root = document.querySelector('[data-floor-fitout]');
  if (!root) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  root.classList.add('js-ready');

  var io = new IntersectionObserver(function (entries, obs) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      root.classList.add('is-visible');
      obs.disconnect();
    });
  }, { threshold: 0.12 });

  io.observe(root);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cdi-cmsl-inclusions-split"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('cdi-incl-split')) {
  customElements.define(
    'cdi-incl-split',
    class CdiInclSplit extends HTMLElement {
      connectedCallback() {
        if (this._ready) return;
        this._ready = true;
        this.panels = Array.from(this.querySelectorAll('[data-panel]'));
        this.tabs = Array.from(this.querySelectorAll('[data-tab]'));
        this.descEl = this.querySelector('[data-split-desc]');
        this.stage = this.querySelector('[data-stage]');
        this.desktop = window.matchMedia('(min-width: 990px)');
        this.reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.active = 0;
        this._inView = false;
        this._raf = 0;

        if (!this.reduce.matches) this.classList.add('js-ready');

        this.panels.forEach((panel, i) => {
          panel.addEventListener('pointerenter', () => {
            if (!this.desktop.matches) return;
            clearTimeout(this._hoverTimer);
            this._hoverTimer = setTimeout(() => {
              if (this.stage) {
                this.stage.classList.add('is-hovering');
                this.stage.classList.remove('is-neutral');
              }
              this.activate(i, true);
            }, 110);
          });
          panel.addEventListener('pointerleave', () => {
            clearTimeout(this._hoverTimer);
          });
          panel.addEventListener('focusin', () => {
            if (!this.desktop.matches) return;
            if (this.stage) {
              this.stage.classList.add('is-hovering');
              this.stage.classList.remove('is-neutral');
            }
            this.activate(i, true);
          });
        });
        if (this.stage) {
          this.stage.addEventListener('pointerleave', () => {
            clearTimeout(this._hoverTimer);
            if (this.desktop.matches) this.deactivate();
          });
          this.stage.addEventListener('focusout', (e) => {
            if (!this.desktop.matches) return;
            const next = e.relatedTarget;
            if (next && this.stage.contains(next)) return;
            this.deactivate();
          });
        }
        this.tabs.forEach((tab) => {
          tab.addEventListener('click', () => {
            const i = Number(tab.getAttribute('data-tab') || 0);
            this.activate(i, true);
          });
        });

        this._io = new IntersectionObserver(
          (entries) => {
            const on = entries[0] && entries[0].isIntersecting;
            this._inView = !!on;
            if (on) {
              this.classList.add('is-visible');
              const current = this.panels[this.active];
              this._bumpPreload(current && current.querySelector('video'));
              this.activate(this.active, true);
            } else {
              this.pauseAll();
            }
          },
          { threshold: 0.12 }
        );
        this._io.observe(this);
      }

      _bumpPreload(video) {
        if (!video || video._preloadBumped) return;
        video._preloadBumped = true;
        if (video.readyState < 2) {
          try {
            video.preload = 'auto';
            video.load();
          } catch (err) {}
        }
      }

      activate(index, play) {
        this.active = index;
        this.panels.forEach((panel, i) => {
          const on = i === index;
          panel.classList.toggle('is-active', on);
          if (!on) this.pausePanel(panel);
        });
        this.tabs.forEach((tab, i) => {
          const on = i === index;
          tab.classList.toggle('is-active', on);
          tab.setAttribute('aria-selected', on ? 'true' : 'false');
        });
        const current = this.panels[index];
        if (this.descEl && current) {
          this.descEl.innerHTML = current.getAttribute('data-desc') || '';
        }
        if (play && this._inView && !this.reduce.matches) this.playPanel(current);
        else if (!play) this.pauseAll();
      }

      deactivate() {
        clearTimeout(this._hoverTimer);
        if (this.stage) {
          this.stage.classList.remove('is-hovering');
          this.stage.classList.add('is-neutral');
        }
        this.pauseAll();
      }

      playPanel(panel) {
        if (!panel) return;
        cancelAnimationFrame(this._raf);
        clearTimeout(this._restartTimer);
        this.panels.forEach((item) => {
          if (item !== panel) this.pausePanel(item);
        });
        panel.classList.add('is-playing');
        const video = panel.querySelector('video');
        if (!video || this.reduce.matches) return;
        const needsRestart = video.currentTime > 0.05;
        const restart = () => {
          try {
            video.currentTime = 0;
          } catch (err) {}
          const run = video.play();
          if (run && typeof run.catch === 'function') run.catch(function () {});
          this._tick(panel, video);
        };
        if (needsRestart) {
          panel.classList.add('is-restarting');
          this._restartTimer = setTimeout(() => {
            if (!panel.classList.contains('is-playing')) return;
            panel.classList.remove('is-restarting');
            restart();
          }, 180);
        } else {
          restart();
        }
      }

      pausePanel(panel) {
        if (!panel) return;
        panel.classList.remove('is-playing', 'is-restarting');
        const video = panel.querySelector('video');
        if (video) video.pause();
        const bar = panel.querySelector('[data-bar]');
        if (bar) bar.style.transform = 'scaleX(0)';
      }

      pauseAll() {
        cancelAnimationFrame(this._raf);
        clearTimeout(this._restartTimer);
        clearTimeout(this._hoverTimer);
        this.panels.forEach((panel) => this.pausePanel(panel));
      }

      _tick(panel, video) {
        const bar = panel.querySelector('[data-bar]');
        const step = () => {
          if (!panel.classList.contains('is-playing')) return;
          const d = video.duration;
          const p = d && isFinite(d) ? video.currentTime / d : 0;
          if (bar) bar.style.transform = 'scaleX(' + p + ')';
          this._raf = requestAnimationFrame(step);
        };
        this._raf = requestAnimationFrame(step);
      }

      disconnectedCallback() {
        if (this._io) this._io.disconnect();
        this.pauseAll();
      }
    }
  );
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cdi-cmsl-vehicle-range"] && !Shopify.designMode) return;
  try {
    
(function () {
  var root = document.querySelector('[data-cmsl-range]');
  if (!root) return;
  var selects = Array.prototype.slice.call(root.querySelectorAll('[data-range-select]'));
  if (!selects.length) return;

  var base = root.dataset.builderUrl;
  var i18n = {
    other: root.dataset.otherLabel || 'Other / not listed',
    dual: root.dataset.cabDual || 'Dual cab',
    single: root.dataset.cabSingle || 'Single cab'
  };

  function cardCta(sel) {
    var card = sel.closest('.cmsl-range__card');
    return card ? card.querySelector('[data-range-cta]') : null;
  }

  function queryFor(sel) {
    var value = sel.value;
    var cta = cardCta(sel);
    if (!value) return cta ? cta.dataset.defaultQuery : 'from=range';
    if (sel.dataset.family === 'lc79') {
      return 'from=range&vehicle=lc79&cab=' + encodeURIComponent(value);
    }
    var q = 'from=range&vehicle=' + encodeURIComponent(value);
    if (sel.dataset.cab) q += '&cab=' + encodeURIComponent(sel.dataset.cab);
    return q;
  }

  function arm(a) {
    if (a && a.dataset.query) a.href = base + '?' + a.dataset.query;
  }

  root.querySelectorAll('[data-range-cta], [data-range-note] a[href="' + base + '"]').forEach(function (a) {
    if (!a.dataset.query) a.dataset.query = 'from=range&vehicle=other';
    ['pointerdown', 'focus', 'contextmenu'].forEach(function (type) {
      a.addEventListener(type, function () { arm(a); });
    });
  });

  selects.forEach(function (sel) {
    sel.addEventListener('change', function () {
      var cta = cardCta(sel);
      if (!cta) return;
      cta.dataset.query = queryFor(sel);
      if (document.activeElement === cta) arm(cta);
    });
  });

  function has(v, cab) {
    return Array.isArray(v.cabs) && v.cabs.indexOf(cab) !== -1;
  }

  function vehiclesFor(family, list) {
    var named = list.filter(function (v) { return v.code !== 'other'; });
    if (family === 'dual') return named.filter(function (v) { return has(v, 'Dual') && (v.family === 'std' || v.family === 'pm1900'); });
    if (family === 'extra') return named.filter(function (v) { return has(v, 'Extra') && v.family === 'std'; });
    if (family === 'single') return named.filter(function (v) { return has(v, 'Single') && v.family === 'std'; });
    if (family === 'us') return named.filter(function (v) { return v.family === 'us'; });
    return [];
  }

  function addOption(sel, value, label) {
    var opt = document.createElement('option');
    opt.value = value;
    opt.textContent = label;
    sel.appendChild(opt);
  }

  function fill(list) {
    var hasOther = list.some(function (v) { return v.code === 'other'; });
    selects.forEach(function (sel) {
      var family = sel.dataset.family;
      if (family === 'lc79') {
        var lc = list.filter(function (v) { return v.family === 'lc79'; })[0];
        (lc ? lc.cabs : []).forEach(function (cab) {
          addOption(sel, cab, cab === 'Single' ? i18n.single : i18n.dual);
        });
      } else {
        vehiclesFor(family, list).forEach(function (v) { addOption(sel, v.code, v.label); });
        if (hasOther) addOption(sel, 'other', i18n.other);
      }
      var host = sel.closest('cdi-selectx');
      var trigger = host && host.querySelector('[data-range-trigger]');
      if (host && typeof host.refreshOptions === 'function') host.refreshOptions();
      if (trigger) trigger.disabled = sel.options.length < 2;
    });
  }

  function load() {
    var controller = 'AbortController' in window ? new AbortController() : null;
    var timer = setTimeout(function () { if (controller) controller.abort(); }, 8000);
    fetch(root.dataset.proxy + '/vehicles', {
      headers: { Accept: 'application/json' },
      signal: controller ? controller.signal : undefined
    })
      .then(function (res) { return res.ok ? res.json() : null; })
      .then(function (data) {
        clearTimeout(timer);
        if (!data || !data.ok || !Array.isArray(data.vehicles)) throw new Error('bad_response');
        fill(data.vehicles);
      })
      .catch(function () {
        clearTimeout(timer);
        root.classList.add('is-list-unavailable');
      });
  }

  if (typeof window.IntersectionObserver === 'function') {
    var io = new IntersectionObserver(function (entries) {
      if (!entries.some(function (e) { return e.isIntersecting; })) return;
      io.disconnect();
      load();
    }, { rootMargin: '600px 0px' });
    io.observe(root);
  } else {
    load();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cdi-contact-form"] && !Shopify.designMode) return;
  try {
    
(function () {
  var form = document.getElementById('CdiContactForm');
  if (!form) return;

  var params = new URLSearchParams(window.location.search);
  var productHandle = params.get('product');
  var productTitle = params.get('title');

  if (productTitle) {
    var msg = form.querySelector('[data-contact-message]');
    if (msg && !msg.value) {
      msg.value = "I'm enquiring about: " + decodeURIComponent(productTitle);
    }
    var typeSelect = form.querySelector('[data-contact-enquiry-type]');
    if (typeSelect && typeSelect.value === '') {
      var title = productTitle.toLowerCase();
      var options = typeSelect.options;
      for (var i = 0; i < options.length; i++) {
        var val = options[i].value.toLowerCase();
        if (title.indexOf('tray') !== -1 && val === 'ute tray') { typeSelect.selectedIndex = i; break; }
        if (title.indexOf('canopy') !== -1 && val === 'canopy') { typeSelect.selectedIndex = i; break; }
        if (title.indexOf('service body') !== -1 && val === 'service body') { typeSelect.selectedIndex = i; break; }
        if (title.indexOf('toolbox') !== -1 && val === 'toolboxes') { typeSelect.selectedIndex = i; break; }
      }
    }
  }

  if (productHandle) {
    var productField = form.querySelector('[data-contact-product]');
    if (productField) productField.value = productHandle;
  }

}());

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cdi-contact-layout"] && !Shopify.designMode) return;
  try {
    
(function () {
  var form = document.getElementById('CdiContactForm');
  if (!form) return;

  var params = new URLSearchParams(window.location.search);
  var productHandle = params.get('product');
  var productTitle = params.get('title');

  if (productTitle) {
    var msg = form.querySelector('[data-contact-message]');
    if (msg && !msg.value) {
      msg.value = "I'm enquiring about: " + decodeURIComponent(productTitle);
    }
    var typeSelect = form.querySelector('[data-contact-enquiry-type]');
    if (typeSelect && typeSelect.value === '') {
      var title = productTitle.toLowerCase();
      var options = typeSelect.options;
      for (var i = 0; i < options.length; i++) {
        var val = options[i].value.toLowerCase();
        if (title.indexOf('tray') !== -1 && val === 'ute tray') { typeSelect.selectedIndex = i; break; }
        if (title.indexOf('canopy') !== -1 && val === 'canopy') { typeSelect.selectedIndex = i; break; }
        if (title.indexOf('service body') !== -1 && val === 'service body') { typeSelect.selectedIndex = i; break; }
        if (title.indexOf('toolbox') !== -1 && val === 'toolboxes') { typeSelect.selectedIndex = i; break; }
      }
    }
  }

  if (productHandle) {
    var productField = form.querySelector('[data-contact-product]');
    if (productField) productField.value = productHandle;
  }

}());

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cdi-footer"]) return;
  try {
    
(function() {
  function openDesktopAccordions() {
    if (window.innerWidth < 750) return;
    document.querySelectorAll('.cdi-footer__accordion').forEach(function(el) {
      el.setAttribute('open', '');
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', openDesktopAccordions);
  } else {
    openDesktopAccordions();
  }
  window.addEventListener('resize', openDesktopAccordions);
})();
(function () {
  var SPEED = 0.8;
  var track = document.querySelector('[data-ticker-track]');
  var set   = track && track.querySelector('[data-ticker-set]');
  var band  = document.querySelector('[data-ticker-band]');
  if (!track || !set || !band) return;

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var pos    = 0;
  var setW   = 0;
  var paused = false;
  function tick() {
    if (!paused) {
      pos -= SPEED;
      if (pos <= -setW) {
        pos += setW;
      }
      track.style.transform = 'translateX(' + pos + 'px)';
    }
    requestAnimationFrame(tick);
  }
  function start() {
    setW = set.getBoundingClientRect().width;
    if (setW <= 0) return;
    var needed = window.innerWidth * 2 + setW;
    while (track.scrollWidth < needed) {
      var clone = set.cloneNode(true);
      clone.removeAttribute('data-ticker-set');
      clone.setAttribute('aria-hidden', 'true');
      clone.querySelectorAll('a').forEach(function (a) {
        a.setAttribute('tabindex', '-1');
      });
      track.appendChild(clone);
    }
    requestAnimationFrame(tick);
  }
  band.addEventListener('mouseenter', function () { paused = true; });
  band.addEventListener('mouseleave', function () { paused = false; });
  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(start);
  } else {
    window.addEventListener('load', start);
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cdi-product-content-tabs"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  function initTabGroup(container) {
    var tabs = Array.from(container.querySelectorAll('[role="tab"]'));
    var panels = Array.from(container.querySelectorAll('[role="tabpanel"]'));

    var observer = null;
    var scrolling = false;
    var scrollTimer = null;

    function setActiveTab(selectedTab) {
      tabs.forEach(function (tab) {
        tab.setAttribute('aria-selected', String(tab === selectedTab));
      });
    }

    function scrollToPanel(tab) {
      var targetId = tab.getAttribute('aria-controls');
      var panel = document.getElementById(targetId);
      if (!panel) return;

      scrolling = true;
      clearTimeout(scrollTimer);
      setActiveTab(tab);

      var navBar = container.querySelector('.cdi-content-tabs__nav-bar');
      var navH = navBar ? navBar.offsetHeight : 0;
      var targetY = panel.getBoundingClientRect().top + window.scrollY - navH;
      window.scrollTo({ top: targetY, behavior: 'smooth' });

      scrollTimer = setTimeout(function () {
        scrolling = false;
      }, 800);
    }

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        scrollToPanel(tab);
      });

      tab.addEventListener('keydown', function (e) {
        var idx = tabs.indexOf(tab);
        var next = null;
        if (e.key === 'ArrowRight') {
          next = tabs[(idx + 1) % tabs.length];
        } else if (e.key === 'ArrowLeft') {
          next = tabs[(idx - 1 + tabs.length) % tabs.length];
        } else if (e.key === 'Home') {
          next = tabs[0];
        } else if (e.key === 'End') {
          next = tabs[tabs.length - 1];
        }
        if (next) {
          next.focus();
          scrollToPanel(next);
        }
      });
    });

    if ('IntersectionObserver' in window) {
      var navBar = container.querySelector('.cdi-content-tabs__nav-bar');
      var navH = navBar ? navBar.offsetHeight : 0;
      var rootMarginTop = '-' + (navH + 20) + 'px';

      observer = new IntersectionObserver(function (entries) {
        if (scrolling) return;
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          var panelId = entry.target.id;
          var matchTab = tabs.find(function (t) {
            return t.getAttribute('aria-controls') === panelId;
          });
          if (matchTab) setActiveTab(matchTab);
        });
      }, {
        rootMargin: rootMarginTop + ' 0px -60% 0px',
        threshold: 0,
      });

      panels.forEach(function (panel) {
        observer.observe(panel);
      });
    }
  }

  document.querySelectorAll('[data-cdi-tabs]').forEach(initTabGroup);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cdi-sticky-atc"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  function initStickyAtc(container) {
    var btn = container.querySelector('[data-cdi-sticky-btn]');
    var priceEl = container.querySelector('[data-cdi-sticky-price]');

    var atcBtn = null;
    var observer = null;

    var basePrice = priceEl ? (parseInt(priceEl.dataset.basePrice, 10) || 0) : 0;

    function findAtcBtn() {
      var candidates = document.querySelectorAll('[id^="ProductSubmitButton-"]');
      if (candidates.length > 0) return candidates[0];
      return null;
    }

    function show() {
      container.setAttribute('data-visible', '');
      container.setAttribute('aria-hidden', 'false');
    }

    function hide() {
      container.removeAttribute('data-visible');
      container.setAttribute('aria-hidden', 'true');
    }

    function formatMoney(cents) {
      if (typeof window.cdiFormatMoney === 'function') {
        return window.cdiFormatMoney(cents, window.cdiMoneyFormat);
      }
      return (cents / 100).toFixed(2);
    }

    subscribe('cdi:addonSync', function (event) {
      if (!priceEl) return;
      var addonTotal = event && event.addonTotal ? event.addonTotal : 0;
      var hasAddons  = addonTotal > 0;

      priceEl.textContent = formatMoney(basePrice + addonTotal);

      var mainAtcBtn  = document.querySelector('[id^="ProductSubmitButton-"]');
      var mainAtcWrap = mainAtcBtn ? mainAtcBtn.closest('.product-form__buttons') : null;

      if (hasAddons) {
        container.setAttribute('data-addon-mode', '');
        container.setAttribute('aria-hidden', 'false');
        if (mainAtcWrap) mainAtcWrap.classList.add('is-hidden-by-addon');
      } else {
        container.removeAttribute('data-addon-mode');
        if (mainAtcWrap) mainAtcWrap.classList.remove('is-hidden-by-addon');
        if (atcBtn) {
          var rect   = atcBtn.getBoundingClientRect();
          var inView = rect.top >= 0 && rect.bottom <= window.innerHeight;
          if (inView) { hide(); } else { show(); }
        }
      }
    });

    function setupObserver() {
      atcBtn = findAtcBtn();
      if (!atcBtn) return;

      observer = new IntersectionObserver(
        function (entries) {
          var entry = entries[0];
          if (entry.isIntersecting) {
            hide();
          } else {
            show();
          }
        },
        { threshold: 0, rootMargin: '0px' }
      );
      observer.observe(atcBtn);
    }

    function handleStickyClick() {
      if (container.dataset.enquiryMode === 'true') {
        var eUrl = container.dataset.enquiryUrl || '/pages/tray-canopy-enquiry';
        var variantInput = document.querySelector('input.product-variant-id');
        var vid = variantInput ? variantInput.value : '';
        window.location.href = eUrl + '?product=' + encodeURIComponent(container.dataset.productHandle || '') + '&variant=' + vid;
        return;
      }
      if (!atcBtn) atcBtn = findAtcBtn();
      if (atcBtn && !atcBtn.disabled) {
        atcBtn.click();
      }
    }

    if (btn) {
      btn.addEventListener('click', handleStickyClick);
    }

    var enquiryMode   = container.dataset.enquiryMode   === 'true';
    var preorderMode  = container.dataset.preorderMode  === 'true';
    var labelAtc      = container.dataset.labelAddToCart  || 'Add to cart';
    var labelPreOrder = container.dataset.labelPreOrder   || 'Pre-order';
    var labelEnquire  = container.dataset.labelEnquireNow || 'Enquire now';
    var labelSoldOut  = container.dataset.labelSoldOut    || 'Sold out';

    function getStickyLabel(variant) {
      if (enquiryMode) return labelEnquire;
      if (!variant || !variant.available) return labelSoldOut;
      var mgmt   = variant.inventory_management;
      var qty    = variant.inventory_quantity;
      var policy = variant.inventory_policy;
      var isOos  = mgmt === 'shopify' && qty <= 0 && policy === 'continue';
      if (isOos && preorderMode)  return labelPreOrder;
      return labelAtc;
    }

    subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
      if (!event || !event.data) return;
      var variant = event.data.variant;

      if (variant) {
        basePrice = variant.price || 0;
        document.querySelectorAll('[data-addon-select]:checked').forEach(function (el) {
          el.checked = false;
        });
        if (window.cdiAddonSync) window.cdiAddonSync();
        if (priceEl) priceEl.textContent = formatMoney(basePrice);
      }

      if (btn && variant) {
        btn.disabled = !variant.available;
        var sectionId = event.data.sectionId;
        var fetchedSpan = event.data.html
          && event.data.html.getElementById('ProductSubmitButton-' + sectionId)
          && event.data.html.getElementById('ProductSubmitButton-' + sectionId).querySelector('[data-atc-label]');
        btn.textContent = fetchedSpan ? fetchedSpan.textContent.trim() : getStickyLabel(variant);
      }
    });

    var sectionWrapper = container.closest('.shopify-section') || container.parentElement;
    if (sectionWrapper && sectionWrapper !== document.body) {
      document.body.appendChild(sectionWrapper);
    }

    if ('IntersectionObserver' in window) {
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', setupObserver);
      } else {
        setupObserver();
      }
    }
  }

  document.querySelectorAll('[data-cdi-sticky-atc]').forEach(initStickyAtc);

  (function bindScrollHide() {
    if (!document.querySelector('[data-cdi-sticky-atc]')) return;

    var idleTimer = 0;

    function chatOpen() {
      return !!document.querySelector('.cdi-chat-shell.is-open');
    }

    function markActive() {
      window.clearTimeout(idleTimer);
      if (chatOpen()) {
        document.body.removeAttribute('data-cdi-scroll-active');
        return;
      }
      document.body.setAttribute('data-cdi-scroll-active', '');
    }

    function markIdle() {
      document.body.removeAttribute('data-cdi-scroll-active');
    }

    if ('onscrollend' in window) {
      window.addEventListener('scroll', markActive, { passive: true });
      window.addEventListener(
        'scrollend',
        function () {
          window.clearTimeout(idleTimer);
          idleTimer = window.setTimeout(markIdle, 400);
        },
        { passive: true }
      );
    } else {
      window.addEventListener(
        'scroll',
        function () {
          markActive();
          idleTimer = window.setTimeout(markIdle, 400);
        },
        { passive: true }
      );
    }
  })();
})();
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cdi-support-tabs"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  var container = document.getElementById('cdi-support-tabs');
  if (!container) return;
  var buttons = container.querySelectorAll('.cdi-support-tabs__nav-btn');
  var panels  = container.querySelectorAll('.cdi-support-tabs__panel');
  var panelMap = { 'warranty-info': 'warranty', 'submit-claim': 'claim' };
  buttons.forEach(function (btn) {
    btn.addEventListener('click', function () {
      var target = btn.getAttribute('data-tab');
      buttons.forEach(function (b) {
        b.classList.remove('cdi-support-tabs__nav-btn--active');
        b.setAttribute('aria-selected', 'false');
      });
      panels.forEach(function (p) {
        p.classList.remove('cdi-support-tabs__panel--active');
      });
      btn.classList.add('cdi-support-tabs__nav-btn--active');
      btn.setAttribute('aria-selected', 'true');
      var panelId = 'cdi-support-panel-' + (panelMap[target] || target);
      var targetPanel = container.querySelector('#' + panelId);
      if (targetPanel) targetPanel.classList.add('cdi-support-tabs__panel--active');
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
(function () {
  'use strict';

  function formatMoney(cents, format) {
    if (typeof window.cdiFormatMoney === 'function') {
      return window.cdiFormatMoney(cents, format);
    }
    return (cents / 100).toFixed(2);
  }

  var MAIN = 'product-info[id^="MainProduct-"] ';

  subscribe('cdi:addonSync', function (event) {
    var addonTotal = event && event.addonTotal ? event.addonTotal : 0;
    var hasAddons  = addonTotal > 0;

    document.querySelectorAll(MAIN + '[data-cdi-addon-subtotal]').forEach(function (el) {
      if (hasAddons) {
        el.textContent = 'Add-ons: +' + formatMoney(addonTotal);
        el.classList.add('is-visible');
      } else {
        el.classList.remove('is-visible');
        el.textContent = '';
      }
    });

    document.querySelectorAll(MAIN + '[data-cdi-badge]').forEach(function (el) {
      el.textContent = hasAddons ? 'Sale' : (el.dataset.pct || 'Sale');
    });

    document.querySelectorAll(MAIN + '[data-cdi-main-price]').forEach(function (el) {
      var base = parseInt(el.dataset.basePrice, 10) || 0;
      el.textContent = formatMoney(base + addonTotal, window.cdiPriceFormat);
    });

    document.querySelectorAll(MAIN + '[data-cdi-compare-price]').forEach(function (el) {
      var base = parseInt(el.dataset.baseCompare, 10) || 0;
      el.textContent = formatMoney(base + addonTotal, window.cdiPriceFormat);
    });
  });
})();

(function () {
  'use strict';

  function pushViewItem(itemId, itemName, price, currency) {
    if (typeof gtag === 'function') {
      gtag('event', 'view_item', {
        send_to: 'G-NS48E5VD3K',
        currency: currency,
        value: price,
        items: [{ item_id: itemId || '', item_name: itemName || '', price: price }]
      });
    }
  }

  var pd = window.cdiProductData;
  if (pd) {
    pushViewItem(pd.item_id, pd.item_name, pd.value, pd.currency);
  }

  subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
    var variant = event && event.data && event.data.variant;
    if (!variant) return;
    var currency = (window.cdiProductData && window.cdiProductData.currency) || 'AUD';
    var price = variant.price ? variant.price / 100 : 0;
    pushViewItem(
      variant.sku || String(variant.id),
      (window.cdiProductData && window.cdiProductData.item_name) || '',
      price,
      currency
    );
  });
})();

document.addEventListener('click', function (e) {
  var link = e.target.closest('.cdi-pdp__enquiry-card[data-enquiry-product]');
  if (!link) return;
  e.preventDefault();
  var url = new URL(link.getAttribute('href'), window.location.origin);
  url.searchParams.set('product', link.dataset.enquiryProduct);
  if (link.dataset.enquiryTitle) {
    url.searchParams.set('title', link.dataset.enquiryTitle);
  }
  window.location.href = url.toString();
});

  } catch(e) { console.error(e); }
})();
})();
